export default __webpack_public_path__ + "static/media/INMED AI STUDIO final-03.b036565e.png";